import { AvailableTemplate, ColumnType, DataCell, ExcelExportDto, TableColumn } from '@ecosystem/export-api';
import { ExportOptions } from '../../types';
import { StatRow } from './types';
import { getExportContext } from '../../export';
import { Formatting } from '../../data/formatting';

export const statsToExportData = (
  { fileHeaderSettings, fileName, contentName }: ExportOptions,
  namesRow: StatRow,
  rows: StatRow[],
  dimmedRows: StatRow[],
  currency: string
): ExcelExportDto => {
  const dataColumns: TableColumn[] = [''].concat(namesRow.values).map((name, idx) => ({
    type: ColumnType.Text,
    header: name,
    style: { width: 20, fontWeight: idx === 0 ? 'bold' : 'normal' },
  }));

  const dataRows: DataCell[][] = rows
    .concat(dimmedRows)
    .map(row => [row.label].concat(row.values).map(value => ({ type: ColumnType.Text, value })));

  const exportData: ExcelExportDto = {
    template: AvailableTemplate.Excel,
    name: fileName,
    worksheets: [
      {
        context: getExportContext(fileHeaderSettings),
        worksheetName: contentName,
        data: {
          dataColumns,
          dataRows,
          currencySymbol: Formatting.getCurrencySymbol(currency),
        },
      },
    ],
  };
  return exportData;
};
